// Chave única para mostrar/esconder a tela "Atribuição de agentes" (Atribuição V2:
// políticas de atribuição e capacidade de agentes), vinda do merge do Chatwoot 4.8.0.
//
// Escondida em 05/10/2026 (decisão Ivan): o motor da V2 (AssignmentService,
// seletores balanced/capacity, PeriodicAssignmentJob) NÃO está ligado neste fork.
// As políticas criadas nessa tela eram salvas, mas ignoradas — a distribuição real
// é a V1 (AutoAssignmentHandler + Inboxes::BulkAutoAssignmentJob).
//
// Para reativar: troque para `true`. Isso volta a registrar as rotas de
// settings/assignment-policy e o item "Atribuição de agentes" na sidebar.
// NÃO mexa na feature flag `assignment_v2` da conta: o
// Inboxes::BulkAutoAssignmentJob (V1) itera `Account.feature_assignment_v2`.
export const ASSIGNMENT_POLICY_UI_ENABLED = false;
